const BASELINE_KEY_PREFIX = 'notifications:baseline:v2:';

export const baselineKey = (userId: string) => `${BASELINE_KEY_PREFIX}${userId}`;

export type Baseline = {
    resubmissions: Record<string, number>;
    documents: string[];
    /** loanRequestId → subscriptionIdentifier for leads that currently have unread Consors notes */
    bankReports: Record<string, string>;
};

export const emptyBaseline = (): Baseline => ({ bankReports: {}, documents: [], resubmissions: {} });

export const readBaseline = (userId: string): Baseline => {
    if (typeof window === 'undefined') return emptyBaseline();
    const raw = window.localStorage.getItem(baselineKey(userId));
    if (!raw) return emptyBaseline();
    try {
        const parsed = JSON.parse(raw) as Partial<Baseline>;
        return {
            bankReports: parsed.bankReports ?? {},
            documents: parsed.documents ?? [],
            resubmissions: parsed.resubmissions ?? {},
        };
    } catch {
        return emptyBaseline();
    }
};

export const writeBaseline = (userId: string, baseline: Baseline) => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(baselineKey(userId), JSON.stringify(baseline));
};
